import { IInquiryKind } from "@Types/inquiry";
import styles from "../../../pages/ask/price.module.less";

import { activityAtom } from "@Lib/jotai/activity";
import { IKindsPcInfo } from "@Types/kindsum";
import { useHover, useSetState } from "ahooks";
import { useAtom } from "jotai";
import React, { useEffect, useRef } from "react";

const Item: React.FC<any> = ({ label, content }) => {
  return (
    <div className='flex gap-4 mt-2'>
      <div className='text-[#999] whitespace-pre'>{label}：</div>
      <div className='text-black' style={{ maxWidth: "230px" }}>
        {content}
      </div>
    </div>
  );
};

const arr = [
  { value: "cashDiscount", label: "現折" },
  { value: "loanDiscount", label: "貸款" },
  { value: "subsidyDiscount", label: "補貼" },
  { value: "warrantyDiscount", label: "保固" },
  { value: "insuranceDiscount", label: "保險" },
  { value: "maintenanceDiscount", label: "保養" },
  { value: "giftDiscount", label: "禮品" },
  { value: "otherDiscount", label: "其他" },
  // { value: "remark", label: "备注" },
];

const OneBrand: React.FC<{
  factoryDiscount: IKindsPcInfo["factoryDiscount"];
  activityStatus: number;
  tcDiscount: string;
}> = ({ factoryDiscount, activityStatus, tcDiscount }) => {
  const { remark, title = "" } = factoryDiscount;

  const [params, setParams] = useSetState({
    value: false,
  });
  const { value } = params;

  useEffect(() => {
    let ob = {
      value: "",
    };
    arr.map((item: any, index: number) => {
      if (factoryDiscount[item.value] !== "") {
        if (ob.value === "") {
          ob.value = factoryDiscount[item.value];
        }
      }
    });

    setParams(ob);
  }, [factoryDiscount]);

  return (
    <div
      className='w-350 flex justify-center  absolute bottom-0 left-12 z-99 rounded-8 cursor-pointer'
      style={{ boxShadow: "0px 4px 20px 0px rgba(0,0,0,0.10)" }}
    >
      <div id={"OneBrand"} className='rounded-8 overflow-hidden'>
        {!!value && (
          <div
            className='w-full h-36 flex items-center justify-center'
            style={{
              background: "linear-gradient(180deg,#ffece9, #fff9f8)",
              borderBottom: "0.5px solid rgb(255 201 186 / 47%)",
            }}
          >
            <div className='flex gap-8 items-center font-semibold text-14 text-black'>
              <img className='w-26 h-22' src='https://photo.8891.com.tw/2024/10/08/1728373013770598.png' />
              {title}
            </div>
          </div>
        )}

        <div className='p-10 bg-[#FFFDFC] flex flex-wrap gap-10'>
          {!!value && (
            <div className='flex gap-10 text-12'>
              <div
                className='text-12 whitespace-pre rounded-4 w-58 flex items-center justify-center h-20 text-[#FF4333]'
                style={{ border: "1px solid #FF4333" }}
              >
                廠商優惠
              </div>
              <div className='grid gap-6 flex-warp' style={{ maxWidth: "260px", flexWrap: "wrap" }}>
                {arr.map(
                  (item: any, index: number) =>
                    !!factoryDiscount[item.value] && (
                      <Item label={item.label} content={factoryDiscount[item.value]} key={index} />
                    ),
                )}
              </div>
            </div>
          )}

          <div className='w-350 text-right text-10 text-[#999] pl-66 flex justify-end'>
            <div className='text-left'>{remark}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

// A样式鼠标划入
const AItem: React.FC<{
  factoryDiscount: IKindsPcInfo["factoryDiscount"];
  activityStatus?: number;
  tcDiscount: string;
}> = ({ factoryDiscount, activityStatus, tcDiscount }) => {
  const [params, setParams] = useSetState({
    value: "",
    label: "",
    valueTwo: "",
    labelTwo: "",
    valueThree: "",
    labelThree: "",
    valueFour: "",
    labelFour: "",
  });
  const { value, label, valueTwo, labelTwo, valueThree, labelThree, valueFour, labelFour } = params;

  useEffect(() => {
    let ob = {
      value: "",
      label: "",
      valueTwo: "",
      labelTwo: "",
      valueThree: "",
      labelThree: "",
      valueFour: "",
      labelFour: "",
    };
    arr.map((item: any, index: number) => {
      if (factoryDiscount[item.value] !== "") {
        if (ob.value === "") {
          ob.value = factoryDiscount[item.value];
          ob.label = item.label;
        } else if (ob.valueTwo === "") {
          ob.valueTwo = factoryDiscount[item.value];
          ob.labelTwo = item.label;
        } else if (ob.valueThree === "") {
          ob.valueThree = factoryDiscount[item.value];
          ob.labelThree = item.label;
        } else if (ob.valueFour === "") {
          ob.valueFour = factoryDiscount[item.value];
          ob.labelFour = item.label;
        }
      }
    });

    setParams(ob);
  }, [factoryDiscount]);

  return (
    <div id='AKindSumRightDiscount' className='w-full -ml-1 bg-cover bg-no-repeat flex relative flex-wrap'>
      <div className='absolute -right-4 top-2 text-[#666]'>右側領取即享</div>
      <div className='w-full flex items-center'>
        <div className='flex gap-8 items-center text-15 font-semibold relative text-black w-full justify-center'>
          <img className='w-26 h-22' src='https://photo.8891.com.tw/2024/10/08/1728373013770598.png' />
          <p>{factoryDiscount.title}</p>
        </div>
      </div>
      <div className='flex gap-8 pt-10'>
        <div className='text-[#FF4333] pr-4'>
          {!!value && (
            <div
              className='text-12 rounded-4 w-58 flex  justify-center h-20'
              style={{ border: "1px solid #FF4333" }}
            >
              廠商優惠
            </div>
          )}
        </div>
        <div className='flex gap-12 flex-wrap items-center text-12'>
          {!!value && (
            <div className=''>
              <div
                className={`${(value.length > 32 || value.length < 18) && valueTwo === "" ? "" : "mb-12"
                  } grid gap-10 w-310`}
              >
                <div className='inline pl-30 relative'>
                  <div className='text-[#999] inline  mr-4 absolute left-0 top-0'>{label}:</div>
                  <div className='text-black inline'>{value}</div>
                </div>
              </div>
              {!!valueTwo && (
                <div
                  className={`${(valueTwo.length > 32 || valueTwo.length < 18) && valueThree === "" ? "" : "mb-12"
                    } grid gap-10 w-310`}
                >
                  <div className='inline pl-30 relative'>
                    <div className='text-[#999] inline  mr-4 absolute left-0 top-0'>{labelTwo}:</div>
                    <div className='text-black inline'>{valueTwo}</div>
                  </div>
                </div>
              )}
              {!!valueThree && (
                <div className={`${valueThree.length > 32 || valueThree.length < 18 ? "" : "mb-12"} grid gap-10 w-310`}>
                  <div className='inline pl-30 relative'>
                    <div className='text-[#999] inline  mr-4 absolute left-0 top-0'>{labelThree}:</div>
                    <div className='text-black inline'>{valueThree}</div>
                  </div>
                </div>
              )}
              {valueFour === "" && (
                <div
                  className={`w-310 block text-[#999] truncate text-right  mb-12 ${factoryDiscount["remark"].length > 22 ? "mt-12" : ""
                    }`}
                >
                  {factoryDiscount["remark"]}
                </div>
              )}
              {valueFour !== "" && <div className='block w-full text-[#999] truncate text-right mb-12'>更多</div>}

              {/* <div
                className={`${
                  !!valueTwo && (value + valueTwo).length < 25 && labelTwo === "貸款" ? "" : "justify-between"
                } flex  mb-12 w-310 gap-4`}
              >
                <div className='inline  mr-10'>
                  <div className='text-[#999] inline mr-4'>{label}:</div>
                  <div className='text-black inline'>{value}</div>
                </div>

                
                {!!valueTwo && (value + valueTwo).length < 22 && labelTwo === "貸款" ? (
                  <div className='inline'>
                    <div className='text-[#999] inline  mr-4'>{labelTwo}:</div>
                    <div className='text-black inline'>{valueTwo}</div>
                  </div>
                ) : (
                  valueTwo === "" && (
                    <div className='text-[#999] truncate w-120 text-right'>{factoryDiscount["remark"]}</div>
                  )
                )}
              </div>

              {!!valueTwo &&
                valueTwo.length > 18 &&
                valueTwo.length < 25 &&
                ((value + valueTwo).length >= 22 || !((value + valueTwo).length < 22 && labelTwo === "貸款")) && (
                  <div className={`mb-12 grid gap-10 w-310 items-end`}>
                    <div className='inline pl-30 relative'>
                      <div className='text-[#999] inline  mr-4 absolute left-0 top-0'>{labelTwo}:</div>
                      <div className='text-black inline whitespace-pre'>{valueTwo}</div>
                    </div>
                    {valueThree === "" && (
                      <div className='block w-full text-[#999] truncate text-right'>{factoryDiscount["remark"]}</div>
                    )}
                  </div>
                )}

              {!!valueTwo &&
                (valueTwo.length < 18 || valueTwo.length > 25) &&
                ((value + valueTwo).length >= 22 || !((value + valueTwo).length < 22 && labelTwo === "貸款")) && (
                  <div className={`mb-12 flex justify-between gap-4 w-310 items-end`}>
                    <div className='inline pl-30 relative'>
                      <div className='text-[#999] inline  mr-4 absolute left-0 top-0'>{labelTwo}:</div>
                      <div className='text-black inline'>{valueTwo}</div>
                    </div>
                    {valueThree === "" && (
                      <div className='inline text-[#999] truncate w-120 text-right'>{factoryDiscount["remark"]}</div>
                    )}
                  </div>
                )}
              {!!valueThree && (
                <div className='flex justify-between mb-12 items-end'>
                  <div className=''>
                    <div className='text-[#999] inline  mr-4'>{labelThree}:</div>
                    <div className='text-black inline'>{valueThree}</div>
                  </div>
                  {!!valueFour && <div className='inline text-[#999] truncate w-28'>更多</div>}
                </div>
              )} */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const DiscountBanner: React.FC<any> = ({ factoryDiscount, tcDiscount }) => {
  const [activityInfo] = useAtom(activityAtom);
  const ref = useRef(null);
  const isHovering = useHover(ref);

  const [params, setParams] = useSetState({
    value: "",
    label: "",
    valueTwo: "",
    labelTwo: "",
    valueThree: "",
    labelThree: "",
    valueFour: "",
    labelFour: "",
  });
  const { value, label, valueTwo, labelTwo, valueThree, labelThree, valueFour, labelFour } = params;

  useEffect(() => {
    let ob = {
      value: "",
      label: "",
      valueTwo: "",
      labelTwo: "",
      valueThree: "",
      labelThree: "",
      valueFour: "",
      labelFour: "",
    };
    arr.map((item: any, index: number) => {
      if (factoryDiscount[item.value] !== "") {
        if (ob.value === "") {
          ob.value = factoryDiscount[item.value];
          ob.label = item.label;
        } else if (ob.valueTwo === "") {
          ob.valueTwo = factoryDiscount[item.value];
          ob.labelTwo = item.label;
        } else if (ob.valueThree === "") {
          ob.valueThree = factoryDiscount[item.value];
          ob.labelThree = item.label;
        } else if (ob.valueFour === "") {
          ob.valueFour = factoryDiscount[item.value];
          ob.labelFour = item.label;
        }
      }
    });

    setParams(ob);
  }, [factoryDiscount]);

  return (
    <div className='w-400 relative ml-20'>
      <img
        className='h-9 absolute z-99'
        style={{ width: "15px", top: "-0.7px", right: "-13px" }}
        src='https://photo.8891.com.tw/2024/10/14/1728873701420230.png'
      />
      <div
        className='w-full rounded-4 relative bg-[#fffaf9] px-10 pt-10'
        style={{ border: "1px solid #ff4433", borderRadius: "4px 0 4px 4px" }}
      >
        <div className='relative' ref={ref}>
          {isHovering && (valueFour !== "" || factoryDiscount["remark"].length > 22) && (
            <OneBrand factoryDiscount={factoryDiscount} activityStatus={activityInfo.activityStatus} tcDiscount={tcDiscount} />
          )}

          <AItem factoryDiscount={factoryDiscount} tcDiscount={tcDiscount} />
        </div>
      </div>
    </div>
  );
};

/** 左側信息描述區域 */
const BrandDesc = (props: { kindData: IInquiryKind; isHide?: boolean; activityInfo: any; adBanner?: string }) => {
  const { kindData, isHide, activityInfo, adBanner } = props;

  const DiscountItem = ({ label, value }) => {
    return (
      value && (
        <div className="h-20 flex justify-start items-center text-12 text-[#333333] w-full">
          <p className="text-[#999] mr-4">{label}:</p>
          {value}
        </div>
      )
    );
  };

  return (
    <div className={`${styles["brand-desc"]} justify-center mt-10`}>
      <div className={styles["brand-thumb"]}>
        {!kindData?.thumb ? (
          <div className={`w-450 h-300 flex justify-center items-center rounded-18 bg-[#F0F6FF] mt-20`}>
            <img
              className='w-214 h-110'
              style={{ width: "216px" }}
              src='https://photo.8891.com.tw/2023/11/01/1698822038777006.png'
            />
          </div>
        ) : (
          <img src={kindData?.thumb} alt='' />
        )}
        <div className={styles["name"]}>
          {kindData?.brandName} {kindData?.kindName}
        </div>
      </div>

      <>
        {/* {!!kindData?.brandName &&
          Object.keys(kindData?.factoryDiscount || {}).length > 0 &&
          !(kindData?.type === "roster" && activityInfo?.activityStatus === 1) && (
            <DiscountBanner factoryDiscount={kindData?.factoryDiscount} />
          )}

        {((!!kindData?.brandName && Object.keys(kindData?.factoryDiscount || {}).length === 0) ||
          kindData?.type === "roster") &&
          activityInfo?.activityStatus === 1 && (
            <img
              className='w-390 h-auto'
              src={adBanner || "https://photo.8891.com.tw/2024/06/05/1717568285104747.png"}
            />
          )} */}

        {/*
          * i5 没厂商优惠没tc 居中: b=6&k=18376
          * ix 没有tc 只显示厂商优惠：b=6&k=17815
          * x6 都有: b=6&k=9582
          * i5 只有tc: b=24&k=10518
         */}
        {/* {Object.keys(kindData?.factoryDiscount || {}).length === 0 && !!kindData?.tcDiscount && (
          <img
            className='w-390 h-auto'
            src={adBanner || "https://photo.8891.com.tw/2024/06/05/1717568285104747.png"}
          />
        )} */}

        {!!kindData?.brandName &&
          Object.keys(kindData?.factoryDiscount || {}).length > 0 &&
          <DiscountBanner factoryDiscount={kindData?.factoryDiscount} tcDiscount={kindData?.tcDiscount} />}
      </>
    </div>
  );
};

export default BrandDesc;
